import { render, staticRenderFns } from "./connections-conflicts-table.vue?vue&type=template&id=e007efb6&scoped=true&"
import script from "./connections-conflicts-table.vue?vue&type=script&lang=js&"
export * from "./connections-conflicts-table.vue?vue&type=script&lang=js&"
import style0 from "./connections-conflicts-table.vue?vue&type=style&index=0&id=e007efb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e007efb6",
  null
  
)

export default component.exports